export default "/images/payment-mir.png?81e7a684aee443f2d46ebf57cfd8c16a";